import { useState, useEffect } from 'react';

import {
  Grid,
  Paper,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Typography,
  TableFooter,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import BlockIcon from '@material-ui/icons/Block';
import SecurityIcon from '@material-ui/icons/Security';
import PersonIcon from '@material-ui/icons/Person';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { BackdropComponent } from '../commons/backdrop/backdrop.component';
import { getUsers, deleteUser, updateUser } from '../../services/users.service';
import { useStyles } from './users.styles';
import { getRoleByUser, deleteUserFromRole, addUserToRole } from '../../services/roles-users.service';

export const UsersComponent = () => {

  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [users, setUsers] = useState([]);
  const [display, setDisplay] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedUser, setSelectedUser] = useState()
  const [modal, setModal] = useState(false);
  const [rolesModal, setRolesModal] = useState(false);
  const [currentRole, setCurrentRole] = useState();

  const fetchUsers = async () => {
    const usersItems = await getUsers();
    setUsers(usersItems);
    setDisplay(usersItems);
    setLoading(false);
  }

  useEffect(() => {
    fetchUsers();
  }, []);

  const onSearch = (event) => {
    const { value } = event.target;
    setDisplay(
      users.filter(user =>
        user.name.toLowerCase().includes(
          value.toLowerCase()
        )
      )
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEdit = (userId) => {
    history.push(`/users/${userId}/edit`);
  }

  const handleDelete = (user) => {
    setSelectedUser(user);
    setModal(true);
  }

  const handleClose = () => {
    setModal(false);
  }

  const handleRolesClose = () => {
    setRolesModal(false);
  }

  const handleDeleteUser = async (userId) => {
    await deleteUser(userId);
    setUsers(users.filter(user => user.id !== userId));
    setDisplay(display.filter(user => user.id !== userId));
    enqueueSnackbar(`Usuario eliminado`, {
      variant: 'success',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' },
    });
    setModal(false);
  }

  const handleActivate = async (user) => {
    const updateItem = {
      ...user,
      active: !user.active
    }
    await updateUser(user.id, updateItem);
    setUsers(users.map(u => u.id === user.id ? updateItem : u));
    setDisplay(display.map(u => u.id === user.id ? updateItem : u))
    enqueueSnackbar(`Usuario ${updateItem.active ? 'Habilitado' : 'Deshabilitado'}`, {
      variant: updateItem.active ? 'success' : 'warning',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' },
    });
  }

  const handleRoles = async (user) => {
    const roleItem = await getRoleByUser(user.id);
    if (roleItem) {
      setCurrentRole(roleItem);
    }
    setSelectedUser(user);
    setRolesModal(true);
  }

  const assignRole = async (roleId) => {
    if (currentRole) {
      await deleteUserFromRole(currentRole.userRole);
    }
    await addUserToRole(roleId, selectedUser.id);
    setRolesModal(false);
    enqueueSnackbar('Rol actualizado', {
      variant: 'success',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' },
    });
  }

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Grid container spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => history.push('/users/new')}
            >
              Agregar usuario
            </Button>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="search">Buscar</InputLabel>
              <OutlinedInput
                id="search"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                labelWidth={60}
                onChange={onSearch}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <BackdropComponent />
            ) : (
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Contacto</TableCell>
                      <TableCell align="right">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {display.length > 0 &&
                      display.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => (
                          <TableRow key={row.id} className={row.active ? '' : classes.desactivate}>
                            <TableCell component="th" scope="row">
                              {row.name}
                            </TableCell>
                            <TableCell align="right">
                              <a href={`tel:${row.phone}`}>{row.phone}</a>
                            </TableCell>
                            <TableCell align="right">
                              <Grid container justifyContent="flex-end" spacing={2}>
                                <Grid item>
                                  <IconButton
                                    aria-label="roles"
                                    color="default"
                                    onClick={() => handleRoles(row)}
                                  >
                                    <SecurityIcon />
                                  </IconButton>
                                </Grid>
                                <Grid item>
                                  <IconButton
                                    aria-label="desactive"
                                    color="default"
                                    onClick={() => handleActivate(row)}
                                  >
                                    <BlockIcon />
                                  </IconButton>
                                </Grid>
                                <Grid item>
                                  <IconButton
                                    aria-label="edit"
                                    color="default"
                                    onClick={() => handleEdit(row.id)}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </Grid>
                                <Grid item>
                                  <IconButton
                                    aria-label="delete"
                                    color="secondary"
                                    onClick={() => handleDelete(row)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))}
                    {display.length === 0 && (
                      <Typography variant="body1" align="center">
                        No hay usuarios
                      </Typography>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TablePagination
                      rowsPerPageOptions={[10, 20, 50]}
                      component="div"
                      count={display.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableFooter>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={modal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          ¿Deseas eliminar el usuario {selectedUser?.name}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Si eliminas esta usuario no podras restablecerla
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => handleDeleteUser(selectedUser?.id)} color="secondary" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={rolesModal}
        onClose={handleRolesClose}
        aria-labelledby="alert-dialog-roles-title"
        aria-describedby="alert-dialog-roles-description"
      >
        <DialogTitle id="alert-dialog-roles-title">
          Asignar rol al usuario {selectedUser?.name}
        </DialogTitle>
        <DialogContent>
          {currentRole && (
            <DialogContentText id="alert-dialog-roles-description">
              Este usuario actualmente es {currentRole.name}
            </DialogContentText>
          )}
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<SecurityIcon />}
                disabled={currentRole && currentRole.id === 'xiY2an912H3CqzGLig8d'}
                onClick={() => assignRole('xiY2an912H3CqzGLig8d')}
              >
                Administrador
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<PersonIcon />}
                disabled={currentRole && currentRole.id === 'Ic4ZHMPjMUIVoDvHs7k5'}
                onClick={() => assignRole('Ic4ZHMPjMUIVoDvHs7k5')}
              >
                Empleado
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRolesClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}